<template>
  <div
    :class="{
      'list-wrapper absolute left-0 top-[3.8125rem] z-10 h-full w-full overflow-auto shadow-[0_8px_16px_0_rgba(0,0,0,.2)] transition-all duration-0 md:h-auto': true,
      'md:-left-18px md:top-[0.1875rem] md:mt-10 md:max-h-[18.5rem] md:min-w-52 md:bg-www-color-accent-blue lg:min-w-[15.75rem] 2xl:top-[0.4375rem] 2xl:min-w-[17.5rem]': true,
      'bg-www-color-neutral-medium-dark': true,
      'lg:border lg:border-t-0 lg:border-[#5C87A6]': true,
    }"
  >
    <!-- Divider in mobile view -->
    <div
      :class="{
        'divider ml-10 mr-25px border-b border-www-color-neutral-medium md:hidden': true,
      }"
    ></div>
    <ul
      :class="{
        'drop-down-list w-full pl-70px pt-5 md:px-5 md:pb-22px md:pt-4': true,
      }"
    >
      <li
        v-for="(link, index) in links"
        :key="index"
        :class="{
          'mb-10px leading-7 last:mb-0': true,
        }"
      >
        <GeneralLink
          :index="index"
          v-bind="link"
          :class="{
            'text-11px font-medium uppercase leading-none text-www-color-white hover:font-bold lg:text-13px 2xl:text-18px': true,
          }"
        />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import type { EducationDropdown } from '~/sanity/types';
import GeneralLink from '~/components/Molecules/HeaderComponents/GeneralLink.vue';
defineProps<EducationDropdown>();
</script>

<style></style>
